export const checklistStatusTypes = Object.freeze({
    IN_PROGRESS: 'IN_PROGRESS',
    NOT_STARTED: 'NOT_STARTED',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS',
    SKIP: 'SKIP',
})

export const checklistErrorTypes = Object.freeze({
    NONE: 'NONE',
    AUDIO_VIDEO: 'AUDIO_VIDEO',
    AUDIO_404: 'AUDIO_404',
    VIDEO_404: 'VIDEO_404',
    DEVICE: 'DEVICE',
    BROWSER: 'BROWSER',
    NETWORK: 'NETWORK',
    ROOM_FULL: 'ROOM_FULL',
    USER_NOT_ALLOWED: 'USER_NOT_ALLOWED',
    TEACHER_ALREADY_PRESENT: 'TEACHER_ALREADY_PRESENT',
})
